module.exports = __webpack_public_path__ + "static/img/Visualization1.91478c51.png";